import FilterFactory from '@/lib/filterFactory';

const enum FilterKey {
    DateFrom = 'paymentDateFrom',
    DateTo = 'paymentDateTo',
    Service = 'medicalServiceType',
    Clinic = 'clinicId',
    Type = 'paymentType',
    Status = 'status',
    IsMobile = 'whereIsMobile',
}

type PaymentType = 'one_stage' | 'two_stage';
type SubscriptionType = 'subscription' | 'quick' | 'planned' | 'at_home' | 'in_clinic';
type PaymentStatus = 'pending' | 'failed' | 'hold_in_process' | 'on_hold' | 'in_process' | 'paid' | 'paid_by_subscription' | 'cancelling_in_process' | 'cancelled';

export default class PaymentsFilter {
    filterHandlers = {
        update: 'paymentsFilter/updateFilter',
        reset: 'paymentsFilter/resetFilter',
        resetState: 'paymentsFilter/resetFilterState',
        removeSelected: 'paymentsFilter/removeSelectedFilter',
    };
    filterModel: Record<string, any>;

    constructor() {
        const filter = new FilterFactory();

        filter.createDatePickerEntity(FilterKey.DateFrom);
        filter.setPlaceholder(FilterKey.DateFrom, 'Дата оплаты от');
        filter.setName(FilterKey.DateFrom, 'search_paymentDate');
        filter.setPreviewName(FilterKey.DateFrom, 'Дата оплаты от');
        filter.setClassName(FilterKey.DateFrom, 'col-1-row-1');
        filter.setIconClassName(FilterKey.DateFrom, 'icon-clock');
        filter.setAction(FilterKey.DateFrom, 'paymentsFilter/updateDate');

        filter.createDatePickerEntity(FilterKey.DateTo);
        filter.setPlaceholder(FilterKey.DateTo, 'Дата оплаты до');
        filter.setName(FilterKey.DateTo, 'search_paymentDate');
        filter.setPreviewName(FilterKey.DateTo, 'Дата оплаты до');
        filter.setClassName(FilterKey.DateTo, 'col-2-row-1');
        filter.setIconClassName(FilterKey.DateTo, 'icon-clock');
        filter.setAction(FilterKey.DateTo, 'paymentsFilter/updateDate');

        filter.createAutocompleteEntity(FilterKey.Clinic);
        filter.setPlaceholder(FilterKey.Clinic, 'По клинике');
        filter.setName(FilterKey.Clinic, 'search_paymentClinic');
        filter.setPreviewName(FilterKey.Clinic, 'Клиника');
        filter.setClassName(FilterKey.Clinic, 'col-1-row-2');
        filter.setIconClassName(FilterKey.Clinic, 'icon-store');
        filter.setAction(FilterKey.Clinic, 'paymentsFilter/updateSearch');
        filter.setLoad(FilterKey.Clinic, {
            entityName: 'clinics',
        });

        filter.createSelectEntity(FilterKey.Service);
        filter.setPlaceholder(FilterKey.Service, 'По типу услуги');
        filter.setName(FilterKey.Service, 'search_paymentService');
        filter.setPreviewName(FilterKey.Service, 'Тип услуги');
        filter.setClassName(FilterKey.Service, 'col-2-row-2');
        filter.setIconClassName(FilterKey.Service, 'icon-clients');
        filter.setAction(FilterKey.Service, 'paymentsFilter/updateSearch');
        filter.setClearAction(FilterKey.Service, 'paymentsFilter/resetSelect');
        filter.setList<SubscriptionType>(FilterKey.Service, [
            { id: 'subscription', value: 'Подписка' },
            { id: 'quick', value: 'Срочная онлайн-консультация' },
            { id: 'planned', value: 'Запланированная онлайн-консультация' },
            { id: 'at_home', value: 'Консультация на дому' },
            { id: 'in_clinic', value: 'Консультация в клинике' },
        ])

        filter.createSelectEntity(FilterKey.Type);
        filter.setPlaceholder(FilterKey.Type, 'По типу оплаты');
        filter.setName(FilterKey.Type, 'search_paymentType');
        filter.setPreviewName(FilterKey.Type, 'Тип оплаты');
        filter.setClassName(FilterKey.Type, 'col-1-row-3');
        filter.setIconClassName(FilterKey.Type, 'icon-user-search');
        filter.setAction(FilterKey.Type, 'paymentsFilter/updateSearch');
        filter.setClearAction(FilterKey.Type, 'paymentsFilter/resetSelect');
        filter.setList<PaymentType>(FilterKey.Type, [
            { id: 'one_stage', value: 'Одностадийная' },
            { id: 'two_stage', value: 'Двухстадийная' }
        ])

        filter.createSelectEntity(FilterKey.Status);
        filter.setPlaceholder(FilterKey.Status, 'По статусу оплаты');
        filter.setName(FilterKey.Status, 'search_paymentStatus');
        filter.setPreviewName(FilterKey.Status, 'Статус оплаты');
        filter.setClassName(FilterKey.Status, 'col-2-row-3');
        filter.setIconClassName(FilterKey.Status, 'icon-user-search');
        filter.setAction(FilterKey.Status, 'paymentsFilter/updateSearch');
        filter.setClearAction(FilterKey.Status, 'paymentsFilter/resetSelect');
        filter.setList<PaymentStatus>(FilterKey.Status, [
            { id: 'pending', value: 'Запрос на оплату создан' },
            { id: 'failed', value: 'Оплата не прошла' },
            { id: 'hold_in_process', value: 'Заморозка средств в процессе' },
            { id: 'on_hold', value: 'Средства заморожены на карте' },
            { id: 'in_process', value: 'Запрос на списание средств' },
            { id: 'paid', value: 'Оплачен' },
            { id: 'paid_by_subscription', value: 'Оплачено по подписке' },
            { id: 'cancelling_in_process', value: 'Запрос на отмену заказа' },
            { id: 'cancelled', value: 'Заказ отменён' },
        ])

        filter.createCheckboxEntity(FilterKey.IsMobile);
        filter.setName(FilterKey.IsMobile, 'checkbox_is_mobile');
        filter.setIconClassName(FilterKey.IsMobile, 'icon-check-mark');
        filter.setPreviewName(FilterKey.IsMobile, 'Только мобильные');
        filter.setClassName(FilterKey.IsMobile, 'col-1-row-4');
        filter.setCheckboxList(FilterKey.IsMobile, [
            {
                id: '1',
                name: 'Только мобильные',
                value: FilterKey.IsMobile,
                checked: false,
            }
        ]);
        filter.setAction(FilterKey.IsMobile, 'paymentsFilter/updateCheckbox');

        this.filterModel = filter.filterModel;
    }
}
